var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8002 1.55V13.45C19.8002 13.7562 19.658 13.9714 19.3736 14.0953C19.2788 14.1318 19.1877 14.15 19.1002 14.15C18.9033 14.15 18.7393 14.0807 18.608 13.9422L14.2002 9.53438V11.35C14.2002 12.2177 13.8921 12.9596 13.276 13.5758C12.6598 14.1919 11.9179 14.5 11.0502 14.5H3.3502C2.48249 14.5 1.74056 14.1919 1.12441 13.5758C0.508268 12.9596 0.200195 12.2177 0.200195 11.35V3.65C0.200195 2.78229 0.508268 2.04036 1.12441 1.42422C1.74056 0.808073 2.48249 0.5 3.3502 0.5H11.0502C11.9179 0.5 12.6598 0.808073 13.276 1.42422C13.8921 2.04036 14.2002 2.78229 14.2002 3.65V5.45469L18.608 1.05781C18.7393 0.919271 18.9033 0.85 19.1002 0.85C19.1877 0.85 19.2788 0.868229 19.3736 0.904687C19.658 1.02865 19.8002 1.24375 19.8002 1.55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToLive);
export default __webpack_public_path__ + "static/media/goToLive.7ed3283b5878e11cd139b85aac60cff6.svg";
export { ForwardRef as ReactComponent };